export const environment = {
  production: true,

  baseUrl: 'https://api.ilcorsaronero.it:3005',

  api:{
    articles: '/articles',
    articlesBody: '/articlesBody',
    articlesLatest: '/lastArticles',
    articlesByCategory: '/articlesByCategory',
    guides: '/guides',
    guidesBody: '/GuidesBody',
  }
};
